import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
// import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField, DropdownSelectField, DateField, Icon } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import metadata from './ProPartOffInfoComponent.metadata.json5';
import { TranslatorContext } from '@jutro/legacy/locale';

function ProPartOffInfoComponent(props) {

    const {
        data: ProPartOffInfoVM,
        updateWizardData,
        submissionVM,
        ProPartOffInfoPath
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useContext(TranslatorContext);

    ProPartOffInfoVM.value.isValidationReq = true

    const addProPartOffInfo = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            ProPartOffInfoVM.value = ProPartOffInfoVM.value || []

            const { _xCenter, _dtoName } = ProPartOffInfoVM;

            const ProPartOffInfoObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            ProPartOffInfoVM.pushElement(
                ProPartOffInfoObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, ProPartOffInfoVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            ProPartOffInfoVM.value.splice(index, 1);
            _.set(submissionVM.value, ProPartOffInfoPath, ProPartOffInfoVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, ProPartOffInfoPath, ProPartOffInfoVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow, consistent-return
        (item, index, props) => {
            const { path } = props;

            if (path === 'nam1') {
                const value = item.nam1 ? item.nam1 : '';

                return (
                    <InputField
                        id={index + path}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            // eslint-disable-next-line no-param-reassign
                            item.nam1 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'higLevOfQua2') {
                const value = item.higLevOfQua2 ? item.higLevOfQua2 : '';
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = ProPartOffInfoVM.length > 0 && ProPartOffInfoVM.children[index].higLevOfQua2
                    // eslint-disable-next-line security/detect-object-injection
                    ? ProPartOffInfoVM.children[index].higLevOfQua2.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        onValueChange={(val, changedPath) => {
                            // eslint-disable-next-line no-param-reassign
                            item.higLevOfQua2 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                    />
                );
            }

            if (path === 'exp3') {
                const value = item.exp3 ? item.exp3 : '';

                if(item.higLevOfQua2 === 'Other') {
                    return (
                        <InputField
                            id={index + path}
                            path={path}
                            dataType="String"
                            onValueChange={(val, changedPath) => {
                                // eslint-disable-next-line no-param-reassign
                                item.exp3 = val;
                                handleValueChange(val, changedPath, index);
                            }}
                            value={value}
                        />
                    );
                }

                return (
                    <InputField
                        id={index + path}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            // eslint-disable-next-line no-param-reassign
                            item.exp3 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        readOnly
                    />
                );
            }

            if (path === 'datQua4') {
                const value = item.datQua4 ? item.datQua4 : '';

                return (
                    <DateField
                        id={index + path}
                        value={value}
                        dataType='object'
                        path={path}
                        format="short"
                        layout="full-width"
                        onValueChange={(val, changedPath) => {
                            // eslint-disable-next-line no-param-reassign
                            item.datQua4 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                    />
                );
            }
        }, [ProPartOffInfoVM, handleValueChange, translator])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            (<Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
            // className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" /* className={styles.deleteIcon} */ />
            </Link>)
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`ProPartOffInfoTable`]: {
            data: ProPartOffInfoVM.value,
        }

    }), [ProPartOffInfoVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addProPartOffInfo,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            ProPartOffInfoVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [ProPartOffInfoVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={ProPartOffInfoVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

ProPartOffInfoComponent.propTypes = wizardProps;
export default withRouter(ProPartOffInfoComponent);
